export default __webpack_public_path__ + "static/media/webberDesktopApp.45a7c79c.png";